import { theme } from 'config';

const { breakpoints } = theme.media;

export const screenIsSmall = (width: number): boolean =>
  width <= breakpoints.small;
